/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Typography } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const InfoVirtualCard = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45)

  const assignVirtualCard = async () => {
    props.changeLoader(true);
    setZPos(-1)

    let payload = {
      type_process: "manual",
      customer_uuids: [props.contentModal.uuid],
    };

    let request = await API.service( "assignVirtualCard", payload, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      props.changeAlert(true, "success", "Tarjeta virtual asignada");
      closelightbox();
    }
    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          Asignar Tarjeta Virtual
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            {props.contentModal.hasOwnProperty("name") && 
              <Grid item xs={12} >
                <Typography sx={{color: "#969BA0"}}>Nombre:</Typography>            
                <Typography>{props.contentModal.name}</Typography>            
              </Grid>
            }
            {props.contentModal.hasOwnProperty("name") && 
              <Grid item xs={12} >
                <Typography sx={{color: "#969BA0"}}>Email:</Typography>            
                <Typography>{props.contentModal.email}</Typography>            
              </Grid>
            }
            {props.contentModal.hasOwnProperty("name") && 
              <Grid item xs={12} >
                <Typography sx={{color: "#969BA0"}}>No. Celular:</Typography>            
                <Typography>{props.contentModal.phone}</Typography>            
              </Grid>
            }           
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={assignVirtualCard.bind(this)}>Asignar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default InfoVirtualCard;
